import React, { Component } from "react";
import styles from "./Tools.module.css";
import { reverseHex } from "../../Common";

class ReverseHex extends Component {
  constructor(props) {
    super(props);
    this.state = {hex:"", revHex:""};
  }

  handleInputChange = (event) => {
    this.setState({ hex: event.target.value });
  };

  clickReverseHex = () => {
    const input = this.state.hex;
    this.setState({ 
      revHex: reverseHex(input)
    });
  };

  render() {
    return (
      <div className={`${styles.tools} times mbox`}>
        <h4 className="text-center" title="Reverse hex byte order. Convert little-endian to big-endian and vice versa.">
          <i className="bi bi-box-arrow-right" style={{ color: "brown" }}></i>{" "}
          Reverse Hex String
        </h4>
        <hr />
              <table width="100%">
                <tbody>
                <tr style={{ height: 90 }}>
                  <td>
                    <div className={`${styles.enterHex}`}>Enter Hex String: </div>
                    <div width="100%">
                        <input
                            name="hex"
                            id="revHexInput"
                            type="text"
                            style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                            value={this.state.hex}
                            onChange={this.handleInputChange}
                            placeholder="Enter string in hex format"
                        />
                    </div>
                  </td>
                </tr>
                <tr>
                    <td>
                        <div>
                            <button className="btn btn-primary" title="Reverse hex byte order" onClick={this.clickReverseHex}>Reverse Hex String</button>
                        </div>
                    </td>
                </tr>
                <tr style={{ height: 90 }}>
                  <td>
                    <div className="label">Reversed Hex String: </div>
                    <div width="100%">
                      <input
                          id="revHexResult"
                          readOnly={true}
                          type="text"
                          style={{ width: "100%", padding: "8px", marginTop: "5px", backgroundColor: "lightgray" }}
                          value={this.state.revHex}
                        />
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
      </div>
    );
  }
}

export default ReverseHex;
